import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import messages from "../../../assets/locale/messages";
import { setPageMainTitle } from "../../../utils/Helpers";
import FilterLabel from "../../../components/Filter/FilterLabel";
import FilterDatePicker from "../../../components/Filter/FilterDatePicker";
import dayjs from "dayjs";

const HeaderSection = ({
  showActions,
  fromDateFilterValue,
  toDateFilterValue,
  handleFromDateChange,
  handleToDateChange,
  fromDateHasError,
  toDateHasError,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const { pagesTitles, mimarProfit } = messages[lang];

  useEffect(() => {
    setPageMainTitle("mimarProfit");
  }, []);

  return (
    <>
      <div className="title-search d-flex flex-wrap justify-content-between mb-4 gap-2">
        <div className="d-flex flex-column flex-md-row">
          <div className=" title-search d-flex flex-wrap">
            <Typography
              variant="h4"
              sx={{ flexGrow: 1 }}
              className={`page-title flex-grow-0 ${
                lang === "en" ? "me-3" : "ms-3"
              } align-self-center`}
            >
              {pagesTitles.profitOverview}
            </Typography>
          </div>
        </div>
        {showActions && (
          <div className="d-flex flex-column flex-md-row gap-2">
            <div className="mt-2">
              <FilterLabel />
            </div>
            <FilterDatePicker
              name="from date filter"
              placeholder={mimarProfit.list.filters.fromDatePlaceholder}
              value={fromDateFilterValue}
              label={mimarProfit.list.filters.fromDateLabel}
              onChange={handleFromDateChange}
              wrapperClass="my-0 "
              inputClass=""
              disableFuture
              maxDate={toDateFilterValue ? dayjs(toDateFilterValue) : undefined}
              isInputHasErr={fromDateHasError}
              errMsg="fromTimeShouldBeBeforeToTime"
            />
            {/* filterByToDate */}
            <FilterDatePicker
              name="to date filter"
              placeholder={mimarProfit.list.filters.toDatePlaceholder}
              value={toDateFilterValue}
              label={mimarProfit.list.filters.toDateLabel}
              onChange={handleToDateChange}
              wrapperClass="my-0 "
              inputClass=""
              disableFuture
              minDate={
                fromDateFilterValue ? dayjs(fromDateFilterValue) : undefined
              }
              isInputHasErr={toDateHasError}
              errMsg="ToTimeShouldBeAfterFromTime"
            />
          </div>
        )}
      </div>
    </>
  );
};
export default HeaderSection;
